import React, { useEffect, useState } from "react";
import { clientApi } from "@/lib/http";
import { Trophy, Check, Lock } from "lucide-react";

// Signed-in client's points, progress & badges on the public booking page.
export const RewardsPanel = () => {
  const [r, setR] = useState(null);
  useEffect(() => { clientApi.get("/public/client/rewards").then(({ data }) => setR(data)).catch(() => setR(null)); }, []);
  if (!r?.enabled) return null;
  const nxt = r.next_reward;
  const earned = r.badges.filter((b) => b.earned);
  return (
    <div className="rounded-2xl border border-primary/30 bg-primary/5 p-4 mb-4 space-y-3" data-testid="pub-rewards">
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-full bg-primary/15 flex items-center justify-center shrink-0"><Trophy className="h-5 w-5 text-primary" /></div>
        <div className="flex-1 min-w-0">
          <div className="text-[11px] uppercase tracking-wider text-muted-foreground">{r.program_name}</div>
          <div className="font-heading font-bold text-xl tabular-nums" data-testid="pub-rewards-balance">{r.balance} <span className="text-sm font-normal text-muted-foreground">{r.points_name}</span></div>
        </div>
      </div>
      {nxt && (
        <div className="space-y-1">
          <div className="h-2 rounded-full bg-muted overflow-hidden"><div className="h-full bg-primary" style={{ width: `${Math.min(100, (r.balance / nxt.points_cost) * 100)}%` }} /></div>
          <div className="text-xs text-muted-foreground">{r.balance >= nxt.points_cost ? `You've unlocked ${nxt.name} — ask us at your next visit!` : `${nxt.points_cost - r.balance} ${r.points_name} to go for ${nxt.name}`}</div>
        </div>
      )}
      <div className="flex flex-wrap gap-1.5" data-testid="pub-rewards-badges">
        {r.badges.slice(0, 8).map((b) => <span key={b.key} className={`inline-flex items-center gap-1 h-6 px-2 rounded-full text-[11px] border ${b.earned ? "bg-primary text-primary-foreground border-primary" : "text-muted-foreground border-dashed"}`}>{b.earned ? <Check className="h-3 w-3" /> : <Lock className="h-3 w-3" />}{b.label}</span>)}
      </div>
      {r.challenges.length > 0 && <div className="text-xs text-muted-foreground">{r.challenges.filter((c) => !c.done).map((c) => `${c.name}: ${c.progress}/${c.target}`).join(" · ")}</div>}
      {earned.length === 0 && r.referrals?.length === 0 && <div className="text-xs text-muted-foreground">Refer a friend — tell them to mention your name when they book.</div>}
    </div>
  );
};
